import { useQuery } from "@tanstack/react-query";
import { llmProviderService } from "@/lib/api/services/llm-provider.service";
import { llmProviderKeys } from "../keys/llm-providers.keys";

/** Fetch all LLM providers for the current org */
export function useLLMProviders() {
  return useQuery({
    queryKey: llmProviderKeys.list(),
    queryFn: () => llmProviderService.list(),
    staleTime: 60 * 1000,
  });
}

/** Fetch a single LLM provider by ID */
export function useLLMProvider(id: string) {
  return useQuery({
    queryKey: llmProviderKeys.detail(id),
    queryFn: () => llmProviderService.getById(id),
    enabled: !!id,
  });
}
